import { FormWithRedux } from '../../FormWithRedux';

export class ACCMRI_LSI_RP_CriteriaForm extends FormWithRedux {

    constructor(formIdentifier, parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super(formIdentifier, parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        if(identifier == 'LSI_RP_NoToAll'){
            return this.unselectedExplicitFormDetailsCount(identifier) > 1;
        }
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory(identifier) {
        if (this.getValue('lumbarSpineInjury') == true) {
            if (identifier == 'LSI_RP_NoToAll'){
                return false;
            }

            let values = [
                this.getValue('LSI_lancinatingNervePainRadiatingDownArmWithinNarrowConfine'),
                this.getValue('LSI_uncomfortableAtNightWithPain'),
                this.getValue('LSI_positiveStraightLegRaiseTest'),
                this.getValue('LSI_positiveSlumpTest'),
                this.getValue('LSI_positiveFemoralNerveStretchTest')];

            if (values.includes(true) || values.includes(false)) {
                return true;
            }
        }
        
        return false;
    }

    getValueType() {
        return 'boolean';
    }

    submissionValidation() {
        return [];
    }

    detailString(isSubform) {
        let formDetails = this.getFormDetails();
        let values = formDetails.map((value) => {
            if (value.currentValue == true) {
                return value.title + ': Yes';
            }
        });

        if(values.filter(n => n).length == 0){
            return isSubform ? '' : this.detail;
        }
        
        if (isSubform == true) {
            return values.filter(n => n).join('\n  ');
        }
        return values.filter(n => n).join('\n');
    }

}


// WEBPACK FOOTER //
// ./src/forms/accmri01/Forms/ACCMRI-LSI-RP-CriteriaForm.js